import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importIssuesButtonLabel: {
		id: 'importer-survey.import-issues-button.import-issues-button-label',
		defaultMessage: 'Import issues',
		description: 'The text is shown on a import issues button',
	},
});
